import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const ProgressBar = ({
  value = 50,
  maxValue = 100,
  height = "h-3",
  rounded = "rounded-full",
  bgColor = "bg-gray-200",
  duration = 0.9,
  className,
  segments = [
    { upTo: 40, color: "bg-green-500" },
    { upTo: 100, color: "bg-yellow-500" },
  ],
}) => {
  const prevValue = useRef(0);
  const [mounted, setMounted] = useState(false);

  const percentage = Math.min((value / maxValue) * 100, 100);
  const prevPercentage = Math.min((prevValue.current / maxValue) * 100, 100);

  useEffect(() => {
    prevValue.current = value;
    setMounted(true);
  }, [value]);

  let accumulated = 0;

  return (
    <div
      className={`w-full ${height} ${rounded} ${bgColor} overflow-hidden ${className}`}
    >
      <div className="flex h-full">
        {segments.map((segment, i) => {
          const segmentStart = accumulated;
          const segmentEnd = segment.upTo;
          accumulated = segmentEnd;

          const visibleWidth = Math.max(
            Math.min(percentage, segmentEnd) - segmentStart,
            0,
          );

          const prevVisibleWidth = Math.max(
            Math.min(prevPercentage, segmentEnd) - segmentStart,
            0,
          );

          if (visibleWidth <= 0) return null;

          return (
            <motion.div
              key={i}
              initial={{
                width: mounted ? `${prevVisibleWidth}%` : `${visibleWidth}%`,
              }}
              animate={{ width: `${visibleWidth}%` }}
              transition={{ duration, ease: "easeInOut" }}
              className={`${segment.color} ${height}`}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ProgressBar;
